module.exports = __webpack_public_path__ + "img/c45.f687bae6.png";